<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="title-block">
<h1>Contents</h1>
</div>
<p class="toc1"><br/>
<span href="#/9781847674920_booktitlepage" title="Link target outside of Sample">Title Page</span><br/>
<span href="#/9781847674920_dedication" title="Link target outside of Sample">Dedication</span><br/>
<span href="#/9781847674920_epigraph" title="Link target outside of Sample">Epigraph</span><br/>
<span href="#/9781847674920_introduction" title="Link target outside of Sample">Introduction</span><br/><br/>
<a href="#/9781847674920_part_01">Part One: 1986</a><br/>
<a href="#/9781847674920_chapter_01">Chapter One</a><br/><br/>
<a href="#/9781847674920_part_02">Part Two: 1951</a><br/>
<a href="#/9781847674920_chapter_02">Chapter One</a><br/>
<span href="#/9781847674920_chapter_03" title="Link target outside of Sample">Chapter Two</span><br/>
<span href="#/9781847674920_chapter_04" title="Link target outside of Sample">Chapter Three</span><br/><br/>
<span href="#/9781847674920_part_03" title="Link target outside of Sample">Part Three: 1898–1945</span><br/>
<span href="#/9781847674920_chapter_05" title="Link target outside of Sample">Chapter One</span><br/>
<span href="#/9781847674920_chapter_06" title="Link target outside of Sample">Chapter Two</span><br/>
<span href="#/9781847674920_chapter_07" title="Link target outside of Sample">Chapter Three</span><br/>
<span href="#/9781847674920_chapter_08" title="Link target outside of Sample">Chapter Four</span><br/>
<span href="#/9781847674920_chapter_09" title="Link target outside of Sample">Chapter Five</span><br/>
<span href="#/9781847674920_chapter_10" title="Link target outside of Sample">Chapter Six</span><br/>
<span href="#/9781847674920_chapter_11" title="Link target outside of Sample">Chapter Seven</span><br/>
<span href="#/9781847674920_chapter_12" title="Link target outside of Sample">Chapter Eight</span><br/>
<span href="#/9781847674920_chapter_13" title="Link target outside of Sample">Chapter Nine</span><br/>
<span href="#/9781847674920_chapter_14" title="Link target outside of Sample">Chapter Ten</span><br/>
<span href="#/9781847674920_chapter_15" title="Link target outside of Sample">Chapter Eleven</span><br/>
<span href="#/9781847674920_chapter_16" title="Link target outside of Sample">Chapter Twelve</span><br/>
<span href="#/9781847674920_chapter_17" title="Link target outside of Sample">Chapter Thirteen</span><br/>
<span href="#/9781847674920_chapter_18" title="Link target outside of Sample">Chapter Fourteen</span><br/>
<span href="#/9781847674920_chapter_19" title="Link target outside of Sample">Chapter Fifteen</span><br/>
<span href="#/9781847674920_chapter_20" title="Link target outside of Sample">Chapter Sixteen</span><br/>
<span href="#/9781847674920_chapter_21" title="Link target outside of Sample">Chapter Seventeen</span><br/>
<span href="#/9781847674920_chapter_22" title="Link target outside of Sample">Chapter Eighteen</span><br/>
<span href="#/9781847674920_chapter_23" title="Link target outside of Sample">Chapter Nineteen</span><br/>
<span href="#/9781847674920_chapter_24" title="Link target outside of Sample">Chapter Twenty</span><br/>
<span href="#/9781847674920_chapter_25" title="Link target outside of Sample">Chapter Twenty-One</span><br/>
<span href="#/9781847674920_chapter_26" title="Link target outside of Sample">Chapter Twenty-Two</span><br/>
<span href="#/9781847674920_chapter_27" title="Link target outside of Sample">Chapter Twenty-Three</span><br/>
<span href="#/9781847674920_chapter_28" title="Link target outside of Sample">Chapter Twenty-Four</span><br/>
<span href="#/9781847674920_chapter_29" title="Link target outside of Sample">Chapter Twenty-Five</span><br/>
<span href="#/9781847674920_chapter_30" title="Link target outside of Sample">Chapter Twenty-Six</span><br/>
<span href="#/9781847674920_chapter_31" title="Link target outside of Sample">Chapter Twenty-Seven</span><br/>
<span href="#/9781847674920_chapter_32" title="Link target outside of Sample">Chapter Twenty-Eight</span><br/>
<span href="#/9781847674920_chapter_33" title="Link target outside of Sample">Chapter Twenty-Nine</span><br/><br/>
<span href="#/9781847674920_part_04" title="Link target outside of Sample">Part Four: 1986–7</span><br/>
<span href="#/9781847674920_chapter_34" title="Link target outside of Sample">Chapter One</span><br/><br/>
<span href="#/9781847674920_abouttheauthor" title="Link target outside of Sample">About the Author</span><br/>
<span href="#/9781847674920_chapter_35" title="Link target outside of Sample">Author’s Note</span><br/>
<span href="#/9781847674920_insertedcopyright" title="Link target outside of Sample">Copyright</span><br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847674920_toc.vue?791fbff7